import ComponentWithSocket from '../../../lib/component';
import { Component } from 'vue-property-decorator';
import * as Store from '../../../store';
import { depositorName } from '../../../utils/depositor';

import moment from 'moment';
import 'moment/locale/ro';

moment.locale('ro');

@Component
export default class Depositors extends ComponentWithSocket {
    depositorName = depositorName;
    searchKeywords: string = '';
    data: any = {
        contracts: [],
        contractsCount: 0,
        perPage: 50,
        currentPage: 1,
    };

    constructor() {
        super();

        const applyContracts = (success: boolean, data: any) => {
            this.data.contracts = [];

            if (success) {
                this.data.contractsCount = data.contractsCount;

                const updatedContracts = data.contracts.map((contract: any) => ({
                    ...contract,
                    signedAt: contract.signedAt
                        ? moment(contract.signedAt)
                        : undefined,
                }));

                this.data.contracts.push(...updatedContracts);
            }

            Store.commitLoaderVisibility(this.$store, false);
            this.restoreScrollPosition();
        };

        // Assign session values to store for global dispatch
        this.wsListener.onGet('admin.depositors.contracts', applyContracts);

        this.wsListener.onGet(
            'admin.depositors.contracts.search',
            applyContracts,
        );

        this.wsListener.onDelete(
            'admin.depositors.contracts',
            (success: boolean) => {
                if (success) {
                    this.reloadContracts(this.data.currentPage);
                }
            },
        );
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        // Salvează poziția scroll-ului în sessionStorage
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        sessionStorage.setItem('depositors_list_scroll', scrollPosition.toString());

        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        this.reloadContracts(1);
    }

    reloadContracts(page: any = this.data.currentPage) {
        Store.commitLoaderVisibility(this.$store, true);
        this.data.currentPage = page;

        if (this.searchKeywords) {
            this.wsListener.sendGet('admin.depositors.contracts.search', {
                keywords: this.searchKeywords,
                perPage: this.data.perPage,
                currentPage: page,
            });
            return;
        }

        this.wsListener.sendGet('admin.depositors.contracts', {
            perPage: this.data.perPage,
            currentPage: page,
        });
    }

    restoreScrollPosition() {
        const savedScrollPosition = sessionStorage.getItem('depositors_list_scroll');

        if (savedScrollPosition) {
            // Așteaptă ca DOM-ul să fie actualizat cu noile date
            this.$nextTick(() => {
                // Așteaptă puțin pentru ca elementele să fie complet renderate
                setTimeout(() => {
                    window.scrollTo(0, parseInt(savedScrollPosition, 10));
                    sessionStorage.removeItem('depositors_list_scroll');
                }, 50);
            });
        }
    }

    doDepositorSearch() {
        this.reloadContracts(1);
    }

    doDeleteContract = (_id: string) => {
        if (confirm('Confirmati stergerea contractului?')) {
            Store.commitLoaderVisibility(this.$store, true);
            this.wsListener.sendDelete('admin.depositors.contracts', { _id });
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/depositors/list/index.ts